export default __webpack_public_path__ + "static/media/master.60d5d973.svg";